/** 上部バー（docs/06_ui-ux.md 2 章）：日・時刻・時間倍率・早送り・スタミナ・順位・予報 */
import { el } from '../layout';

export interface TopBarModel {
  dayLabel: string;
  phaseLabel: string;
  clock: string;
  timeScaleLabel: string;
  timeScaleWarn: boolean;
  fastForward: 1 | 2 | 4;
  canFastForward: boolean;
  stamina: number;
  rankLabel: string;
  /** 今のカメラ（ボタンは「もう一方へ切り替える」） */
  view: 'map' | 'follow';
  canToggleView: boolean;
}

export interface TopBarActions {
  setFastForward(level: 1 | 2 | 4): void;
  openForecast(): void;
  toggleView(): void;
}

export function createTopBar(host: HTMLElement, actions: TopBarActions): { render(m: TopBarModel): void } {
  const day = el('span', 'topbar__day');
  const phase = el('span', 'topbar__phase');
  const clock = el('span', 'topbar__clock');
  const scale = el('span', 'topbar__scale');
  const ff = el('span', 'topbar__ff');
  const ffButtons = ([1, 2, 4] as const).map((lv, i) => {
    const b = el('button', 'ff-btn', `×${lv}`);
    b.title = `早送り ×${lv}（${i + 1} キー）`;
    b.addEventListener('click', () => actions.setFastForward(lv));
    ff.appendChild(b);
    return b;
  });
  const spacer = el('span', 'topbar__spacer');
  const stamina = el('span', 'topbar__stamina');
  const staminaBar = el('span', 'stamina-bar');
  const staminaFill = el('span', 'stamina-bar__fill');
  const staminaText = el('span', 'topbar__stamina-text');
  staminaBar.appendChild(staminaFill);
  stamina.append(el('span', 'topbar__label', 'スタミナ'), staminaBar, staminaText);
  const rank = el('span', 'topbar__rank');
  const forecast = el('button', 'btn btn--small', '予報');
  forecast.addEventListener('click', actions.openForecast);
  const view = el('button', 'btn btn--small', '地図');
  view.addEventListener('click', actions.toggleView);
  host.append(
    el('span', 'topbar__brand', 'ALPINE TRAVERSE'),
    day,
    phase,
    clock,
    scale,
    ff,
    spacer,
    stamina,
    rank,
    view,
    forecast,
  );

  return {
    render(m) {
      day.textContent = m.dayLabel;
      phase.textContent = m.phaseLabel;
      clock.textContent = m.clock;
      scale.textContent = m.timeScaleLabel;
      scale.classList.toggle('topbar__scale--warn', m.timeScaleWarn);
      ffButtons.forEach((b, i) => {
        b.classList.toggle('ff-btn--on', [1, 2, 4][i] === m.fastForward);
        b.disabled = !m.canFastForward;
      });
      staminaFill.style.width = `${Math.round(m.stamina)}%`;
      staminaFill.classList.toggle('stamina-bar__fill--low', m.stamina < 30);
      staminaText.textContent = String(Math.round(m.stamina));
      rank.textContent = m.rankLabel;
      view.textContent = m.view === 'follow' ? '地図 M' : '追従 M';
      view.title =
        m.view === 'follow' ? '俯瞰の地図に切り替える（M キー）' : '選手を追うカメラに切り替える（M キー）';
      view.disabled = !m.canToggleView;
    },
  };
}
